import React from 'react';

function ButtonGroup({ moveToNextStep, isComplete, blocked = false, hint }) {
  const canComplete = typeof moveToNextStep === 'function';
  const disabled = !canComplete || blocked;

  const handleCompleteClick = async () => {
    if (disabled) return;
    moveToNextStep();
  };

  const buttonText = canComplete
    ? (isComplete ? 'Completed' : 'Complete')
    : 'Complete';

  return (
    <div className="list-button-group-preview">
      <button
        type="button"
        className={`button-template-preview ${isComplete ? '' : 'border-button'} ${disabled ? 'is-disabled' : ''}`.trim()}
        onClick={handleCompleteClick}
        disabled={disabled}
      >
        <span className="icon-button-template-preview">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M9.26638 15.2686L5.03207 11.0343C4.71965 10.7219 4.21312 10.7219 3.9007 11.0343C3.58828 11.3467 3.58828 11.8533 3.9007 12.1657L8.7007 16.9657C9.01312 17.2781 9.51965 17.2781 9.83207 16.9657L19.4321 7.36569C19.7445 7.05327 19.7445 6.54673 19.4321 6.23431C19.1196 5.9219 18.6131 5.9219 18.3007 6.23431L9.26638 15.2686Z"
              fill="currentColor"
            />
          </svg>
        </span>
        <span className="text-button-template-preview">{buttonText}</span>
      </button>
      {blocked && hint && <p className="un-pe-complete-hint">{hint}</p>}
    </div>
  );
}

export default ButtonGroup;
